import React, { Component } from "react";
import { Link } from "react-router-dom";
import UserImage from "../user_image";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";

class Recommendation extends Component {
  state = {};
  render() {
    const style = { display: "contents", cursor: "pointer" };

    return (
      <Link
        style={style}
        to={"/recommendations/" + this.props.recommendation.id}
      >
        <div className="create_recommendation_ratio recommendation_row_ratio cursor_btn">
          <label>
            {this.renderMedia()}

            {this.renderUserImage()}
          </label>
        </div>
      </Link>
    );
  }

  renderMedia() {
    if (this.props.recommendation.recommendation_type === "image") {
      if (this.props.recommendation.url_title !== "") {
        return (
          <div className="image_url">
            <img
              className="image_media content-cover"
              src={this.props.recommendation.image_url_original}
              alt="upload"
            />
            <div className="div_url">
              <label className="url_title">
                {this.props.recommendation.url_title}
              </label>
              <label className="url_description">
                {this.props.recommendation.url_description}
              </label>
            </div>
          </div>
        );
      }
      return (
        <img
          className="image_media content-cover"
          src={this.props.recommendation.image_url_original}
          alt="upload"
        />
      );
    }
    if (this.props.recommendation.recommendation_type === "video") {
      return (
        <img
          className="image_media content-cover"
          alt=""
          src={this.props.recommendation.video_url_image}
        />
      );
    }
  }

  renderUserImage() {
    if (this.props.username) {
      // We Don't show anything if variable user_id is present => That mean we are under profile page
      return <div />;
    }

    return (
      <React.Fragment>
        <div className="gradient" />
        <div className="recommendation_image">
          <UserImage
            user={this.props.recommendation.user}
            link={false}
            show_name={true}
          />
        </div>
      </React.Fragment>
    );
  }

  renderQuestion() {
    if (this.props.recommendation.question) {
      return (
        <div className="question_icon">
          <FontAwesomeIcon className="question_icon" icon={faQuestion} />
        </div>
      );
    }
    return <div />;
  }
}

export default Recommendation;



// WEBPACK FOOTER //
// ./src/components/recommendation/recommendation.jsx